import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import './NotFound.scss';

const NotFound = () => {
    const { t } = useTranslation();

    return (
        <section className="not-found-section">
            <div className="not-found-content">

                <span className="not-found-subtitle">
                    {t('notFound.subtitle')}
                </span>

                <h1>404</h1>

                <h2>
                    {t('notFound.title')}
                </h2>

                <p>
                    {t('notFound.description')}
                </p>

                <Link
                    to="/"
                    className="not-found-btn"
                >
                    {t('notFound.button')}
                </Link>

            </div>
        </section>
    );
};

export default NotFound;